var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.5H7.5C6.50544 37.5 5.55161 37.1049 4.84835 36.4017C4.14509 35.6984 3.75 34.7446 3.75 33.75V11.0869C3.79206 10.1209 4.20564 9.20842 4.9044 8.54006C5.60315 7.87171 6.53307 7.49909 7.5 7.5H37.5C38.4946 7.5 39.4484 7.89509 40.1516 8.59835C40.8549 9.30161 41.25 10.2554 41.25 11.25V33.75C41.25 34.7446 40.8549 35.6984 40.1516 36.4017C39.4484 37.1049 38.4946 37.5 37.5 37.5ZM7.5 14.7525V33.75H37.5V14.7525L22.5 24.75L7.5 14.7525ZM9 11.25L22.5 20.25L36 11.25H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b5b2cf592f59db9be22750101173a249.svg";
export { ForwardRef as ReactComponent };